import { render, staticRenderFns } from "./splrInfor.vue?vue&type=template&id=4777ab06&scoped=true"
import script from "./splrInfor.vue?vue&type=script&lang=js"
export * from "./splrInfor.vue?vue&type=script&lang=js"
import style0 from "./splrInfor.vue?vue&type=style&index=0&id=4777ab06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4777ab06",
  null
  
)

export default component.exports